
export default [
    // 成本管理列表
    {
        path: "costmanagelist",
        name: "costManageList",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/cost/costmanage/index"),
    },
    {
        path: "costmanageupdate/:type",
        name: "costManageUpdate",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/cost/costmanage/update"),

    },
    // 成本组管理列表
    {
        path: "costgrouplist",
        name: "costGroupList",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/cost/group/index"),
    },
    {
        path: "costgroupupdate/:type",
        name: "costGroupUpdate",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/cost/group/update"),
    },
]